import Step from '@/step';

export default class StepFour extends Step {
    constructor(stepNumber) {
        super(stepNumber);
        this.apiRoute = `/step-4`;
    }
}